import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Table, Button, Form, Card, Pagination } from "react-bootstrap";
import ModalCuentaAdmin from "./modaladmin/ModalCuentaAdmin";
import ModalChangePassword from "./modaladmin/ModalChangePassword";
import Procedimientos from "./Procedimientos";
import Tipo from "./Tipos";
import Swal from "sweetalert2";
import { getlegajosbyliquidacion } from "../../../api/marcacionApi";
import * as XLSX from "xlsx";
import {
  insertAdmin,
  updateAdmin,
  getAllAdmin,
  UpdateEstadoAdmin,
  changePasswordAdmin,
  getAdminCredentials,
   getAllOtpLogs,
} from "../../../api/AdminApi";
import { getOtpCode } from "../../../api/OtpApi";
import { TiMinus, TiPlus } from "react-icons/ti";

const showReducer = (curShow, state) => {
  switch (state.type) {
    case "SHOW":
      return {
        isShow: true,
        typeModal: state.typeModal,
        onReturnValue: state.onReturnValue,
        item: state.item || null,
      };
    case "END":
      return { ...curShow, isShow: false };
    default:
      return curShow;
  }
};

export const Admin = () => {
  const [admins, setAdmins] = useState([]);
  const [filteredAdmins, setFilteredAdmins] = useState([]);
  const [userdata, setUSERDATA] = useState();
  const [isnewAdmin, setIsnewAdmin] = useState(true);
  const [datoAdmin, setDatoAdmin] = useState([]);
  const [searchId, setSearchId] = useState("");
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(undefined);
  const [otplogs, setOtplogs] = useState([]);
  const [showActivas, setShowActivas] = useState(true);

  // OTP
  const [otpCode, setOtpCode] = useState(null);
  const [countdown, setCountdown] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  // Paginación
  const [currentPageAdmins, setCurrentPageAdmins] = useState(1);
  const [currentPageOtp, setCurrentPageOtp] = useState(1);
  const itemsPerPage = 10;

  const [reducer, dispatchReducer] = useReducer(showReducer, {
    isShow: false,
    typeModal: null,
    onReturnValue: null,
    item: null,
  });

  useEffect(() => {
    const checkPermissionAndLoad = async () => {
      setLoading(true);
      try {
        const USERDATA = await getAdminCredentials();
        if (USERDATA?.IdTipoUsuario !== "0" && USERDATA?.IdTipoUsuario !== "2") {
          setHasPermission(false);
          setLoading(false);
          return;
        }
        setUSERDATA(USERDATA);
        setHasPermission(true);
      } catch {
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };
    checkPermissionAndLoad();
  }, []);

  useEffect(() => {
    if (hasPermission === true) loadAdmins();
  }, [hasPermission]);

  const loadAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getAllAdmin();
      setAdmins(result);
      setFilteredAdmins(result);
      const otplogs = await  getAllOtpLogs();
      setOtplogs(otplogs);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSearchId = (e) => setSearchId(e.target.value);

  const exportToExcel = async () => {
    const data1 = await getlegajosbyliquidacion(searchId);
    const worksheet = XLSX.utils.json_to_sheet(data1);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Liquidacion " + searchId);
    XLSX.writeFile(workbook, "liquidacion_" + searchId + ".xlsx");
  };

  const handleShowNewAdmin = () => {
    setDatoAdmin({ cuenta: "", nombrecompleto: "", idadmin: "" });
    setIsnewAdmin(true);
    dispatchReducer({ type: "SHOW", typeModal: "FERIADO" });
  };

  const handleShowEditAdmin = (data) => {
    setDatoAdmin(data);
    setIsnewAdmin(false);
    dispatchReducer({ type: "SHOW", typeModal: "FERIADO" });
  };

  const handleShowChangePassword = (item) => {
    dispatchReducer({
      type: "SHOW",
      typeModal: "CHANGE_PASSWORD",
      item: { idadmin: item.idadmin, cuenta: item.cuenta },
    });
  };

  const onReturnDataAdmin = async (data, isnew, typeModal) => {
    dispatchReducer({ type: "END" });
    Swal.fire({
      title: "Procesando...",
      allowOutsideClick: false,
      showConfirmButton: false,
    });
    try {
      let result;
      if (typeModal === "CHANGE_PASSWORD") {
        result = await changePasswordAdmin({
          idadmin: data.idadmin,
          cuenta: data.cuenta,
          newPassword: data.newPassword,
        });
      } else if (isnew) {
        result = await insertAdmin(data);
      } else {
        result = await updateAdmin(data);
      }
      Swal.close();
      if (result) {
        Swal.fire({ title: "Listo", icon: "success", timer: 1500, showConfirmButton: false });
        loadAdmins();
      }
    } catch (err) {
      Swal.close();
      Swal.fire({ icon: "error", title: "Error", text: `${err}` });
    }
  };

  const onCloseModal = () => dispatchReducer({ type: "END" });

  const EstadoAdmin = async (id) => {
    const result = await Swal.fire({
      title: "¿Cambiar estado?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    });
    if (result.isConfirmed) {
      await UpdateEstadoAdmin(id);
      Swal.fire({ title: "Actualizado", icon: "success", timer: 1000, showConfirmButton: false });
      loadAdmins();
    }
  };

  const isButtonDisabled = (item) => {
    if (userdata?.IdTipoUsuario === "2") return false;
    if (userdata?.IdTipoUsuario === "0") return item.IdTipoUsuario === "2";
    return true;
  };

  // OTP
  const generarCodigo = async () => {
    setIsGenerating(true);
    try {
      const data = await getOtpCode();
      setOtpCode(data.codigo);
      setCountdown(data.ttl || 30);
      if (intervalId) clearInterval(intervalId);
      const id = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(id);
            setOtpCode(null);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      setIntervalId(id);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.message });
    } finally {
      setIsGenerating(false);
    }
  };

  const copiarCodigo = async () => {
    if (!otpCode) return;
    await navigator.clipboard.writeText(String(otpCode));
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Código copiado",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (loading)
    return (
      <div className="text-center p-5">
        <div className="spinner-border text-primary me-2" role="status"></div>
        Cargando...
      </div>
    );

  if (hasPermission === false)
    return (
      <div className="text-center mt-5">
        <h4>No tiene permisos para ver esta información.</h4>
      </div>
    );

  const paginate = (data, currentPage) =>
    data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const adminsPage = paginate(filteredAdmins, currentPageAdmins);
  const otpPage = paginate(otplogs, currentPageOtp);

  const renderPagination = (total, current, setPage) => {
    const totalPages = Math.ceil(total / itemsPerPage);
    if (totalPages <= 1) return null;
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <Pagination.Item key={i} active={i === current} onClick={() => setPage(i)}>
          {i}
        </Pagination.Item>
      );
    }
    return <Pagination className="justify-content-center mt-2 mb-0">{pages}</Pagination>;
  };

  // === Estilo de botón ícono ===
  const btnIconStyle = {
    width: 30,
    height: 30,
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 6,
  };

  return (
    <div className="row gy-4">
      {/* OTP */}
      <div className="col-12">
        <Card className="shadow-sm border-warning">
          <Card.Header className="bg-warning-subtle text-center fw-semibold">
            🔐 Generador de Código OTP
          </Card.Header>
          <Card.Body className="text-center">
            <Button variant="warning" size="sm" onClick={generarCodigo} disabled={isGenerating}>
              {isGenerating ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Generando...
                </>
              ) : (
                "Generar Código OTP"
              )}
            </Button>

            {otpCode && (
              <div className="alert alert-info mt-3 mb-0 py-2">
                <h5 className="mb-1">{otpCode}</h5>
                <small>Expira en {countdown}s</small>
                <div>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    style={btnIconStyle}
                    className="mt-2"
                    onClick={copiarCodigo}
                  >
                    <i className="far fa-copy fa-sm"></i>
                  </Button>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>

      {/* ADMIN */}
      <div className="col-xl-7 col-lg-7">
        <Card className="shadow-sm">
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">👥 Cuentas Administrativos</h5>
            <Button variant="primary" size="sm" onClick={handleShowNewAdmin}>
              + Agregar
            </Button>
          </Card.Header>
          <Card.Body className="p-0">
            <Table  responsive bordered className="mb-0 text-center align-middle table-sm">
              <thead >
                <tr>
                  <th>#</th>
                  <th>Cuenta</th>
                  <th>Nombre</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {adminsPage.map((item, i) => (
                  <tr key={i}>
                    <td>{item.idadmin}</td>
                    <td>{item.cuenta}</td>
                    <td>{item.nombrecompleto}</td>
                    <td className={item.estado === "INACTIVO" ? "text-danger" : "text-success"}>
                      {item.estado}
                    </td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          style={btnIconStyle}
                          disabled={isButtonDisabled(item)}
                          onClick={() => handleShowEditAdmin(item)}
                        >
                          <i className="fas fa-pen fa-sm"></i>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-warning"
                          style={btnIconStyle}
                          disabled={isButtonDisabled(item)}
                          onClick={() => handleShowChangePassword(item)}
                        >
                          <i className="fas fa-key fa-sm"></i>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          style={btnIconStyle}
                          disabled={isButtonDisabled(item)}
                          onClick={() => EstadoAdmin(item.idadmin)}
                        >
                          <i
                            className={
                              item.estado === "INACTIVO" ? "fas fa-undo fa-sm" : "fas fa-trash fa-sm"
                            }
                          ></i>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {renderPagination(filteredAdmins.length, currentPageAdmins, setCurrentPageAdmins)}
          </Card.Body>
        </Card>
      </div>

      {/* EXPORTAR */}
      <div className="col-xl-5 col-lg-5">
        <Card className="shadow-sm">
          <Card.Header>
            <h5 className="mb-0">📤 Exportar Liquidaciones</h5>
          </Card.Header>
          <Card.Body>
            <Form.Group>
              <Form.Label>ID Liquidación</Form.Label>
              <Form.Control
                type="text"
                value={searchId}
                onChange={handleSearchId}
                placeholder="Ingrese ID"
              />
            </Form.Group>
            <Button variant="success" className="mt-3" onClick={exportToExcel}>
              Descargar Excel
            </Button>
          </Card.Body>
        </Card>
      </div>

      {/* OTP LOGS */}
      <div className="col-12">
        <Card className="shadow-sm">
          <Card.Header>
            <h5 className="mb-0">📜 Historial de Códigos OTP</h5>
          </Card.Header>
          <Card.Body className="p-0">
            <Table  responsive bordered className="mb-0 text-center align-middle table-sm">
              <thead >
                <tr>
                  <th>#</th>
                  <th>Usuario</th>
                  <th>Código</th>
                  
                  <th>Estado</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {otpPage.length > 0 ? (
                  otpPage.map((log, idx) => (
                    <tr key={idx}>
                      <td>{(currentPageOtp - 1) * itemsPerPage + idx + 1}</td>
                      <td>{log.Usuario}</td>
                      <td>{log.codigo}</td>
                     <td>{log.accion}</td>
                      <td>{(log.fechaUso)}</td>
                      
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center py-3">
                      Sin registros recientes
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {renderPagination(otplogs.length, currentPageOtp, setCurrentPageOtp)}
          </Card.Body>
        </Card>
      </div>

      {/* ASISTENCIA */}
      <div className="col-12">
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">📋 Asistencia</h5>
            <i onClick={() => setShowActivas(!showActivas)} style={{ cursor: "pointer" }}>
              {showActivas ? <TiMinus /> : <TiPlus />}
            </i>
          </Card.Header>
          {showActivas && (
            <Card.Body>
              <div className="row">
                <div className="col-lg-6">
                  <Procedimientos />
                </div>
                <div className="col-lg-6">
                  <Tipo />
                </div>
              </div>
            </Card.Body>
          )}
        </Card>
      </div>

      {/* MODALES */}
      {reducer.isShow && reducer.typeModal === "FERIADO" && (
        <ModalCuentaAdmin
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={datoAdmin}
          isnew={isnewAdmin}
        />
      )}
      {reducer.isShow && reducer.typeModal === "CHANGE_PASSWORD" && (
        <ModalChangePassword
          estado={reducer.isShow}
          typeModal={reducer.typeModal}
          onCloseModal={onCloseModal}
          onReturnValue={onReturnDataAdmin}
          item={reducer.item}
        />
      )}
    </div>
  );
};

export default Admin;
